import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/Auth';

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = React.useContext(AuthContext);

  return isAuthenticated ? <Navigate to="/" /> : children;
};

export default PublicRoute;
